import React, { FC, useEffect, createRef, useState, ReactNode } from 'react';

import { isTouchDevice } from '../../utils/domUtils';
import { CursorTracker } from './cursorTracker';
import { Popover } from './Popover';

type Props = {
  renderTemplate: (element: HTMLElement) => ReactNode;
  isPopoverInsideModal?: boolean;
  target?: string;
};

export const PopoverFactoryRenderer: FC<Props> = ({
  isPopoverInsideModal = false,
  target = '[data-doctrine-popover]',
  renderTemplate,
  children,
}) => {
  const [popovers, setPopovers] = useState<Array<ReactNode>>([]);

  const factoryRef = createRef<HTMLSpanElement>();

  useEffect(() => {
    if (factoryRef.current) {
      const cursorTracker = CursorTracker.getInstance();
      const popoverElements = factoryRef.current.querySelectorAll(target);
      const Components: Array<ReactNode> = [];
      Array.from(popoverElements).forEach((element, index) => {
        if (cursorTracker && element instanceof HTMLElement) {
          Components.push(
            <Popover
              key={index} // eslint-disable-line react/no-array-index-key
              element={element}
              getCursorPosition={cursorTracker.getCursorPosition}
              isPopoverInsideModal={isPopoverInsideModal}
            >
              {() => renderTemplate(element)}
            </Popover>,
          );
        }
      });

      setPopovers(Components);
      return () => {
        cursorTracker.removeListener();
      };
    }
  }, []);

  const toucheDevice = isTouchDevice();

  if (toucheDevice) {
    return <>{children}</>;
  }

  return (
    <span ref={factoryRef}>
      {popovers.length > 0 && popovers} {children}
    </span>
  );
};
